import React, { useEffect, useRef } from "react";

interface PreviewFrameProps {
  iframeSrc: string;
  content: string;
  previewInitialized: boolean;
}

export const PreviewFrame = ({
  iframeSrc,
  content,
  previewInitialized,
}: PreviewFrameProps) => {
  const ref = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (ref.current && previewInitialized) {
        ref.current.contentWindow!.postMessage(
          { type: "snippet-show", content },
          "*"
        );
      }
    },400);
  }, [content, previewInitialized]);

  return (
    <iframe
      ref={ref}
      style={{ border: "none", width: "100%", height: "100%" }}
      className="st-preview-body"
      src={iframeSrc}
      allowFullScreen={true}
      allow="clipboard-read; clipboard-write; fullscreen"
    />
  );
};
